import { handleActions } from 'redux-actions';
import * as profileInfoActions from '../../actions/profile/profileActions';

let initialState = {
  info: null,
  loading: false,
  errorMessage: '',
};

export const profileInfo = handleActions(
  {
    //  get profile info
    [profileInfoActions.getProfileInfo]: (state, action) => {
      return { ...state, loading: true };
    },
    [profileInfoActions.getProfileInfoSuccess]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        info: payload,
        loading: false,
      };
    },
    [profileInfoActions.getProfileInfoFailure]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        errorMessage: payload,
        loading: false,
      };
    },
    [profileInfoActions.updateProfileInfo]: (state, action) => {
      return { ...state, loading: true };
    },
    [profileInfoActions.updateProfileInfoSuccess]: (state, action) => {
      return {
        ...state,
        loading: false,
        errorMessage: null,
        info: {
          ...action.payload,
        },
        updateSuccess: state.updateSuccess ? state.updateSuccess + 1 : 1,
      };
    },
    [profileInfoActions.updateProfileInfoFailure]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        errorMessage: payload,
        loading: false,
      };
    },
  },
  initialState
);
